module.exports = __webpack_public_path__ + "static/media/D_8.5795f645.png";